let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = Promise.all([load("ahxSD"), load("7zMjZ"), load("a1dBM"), load("7FkEF"), load("68Kzv"), load("3NvtU"), load("kIlWP")]).then(() => parcelRequire('k3fpw'));